export default __webpack_public_path__ + "static/media/maven-tool.11bb162a.png";